import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router';

import {
  AppBar,
  Drawer,
  ProfileTooltip,
  Button,
} from '../components';
import MediaQuery from 'react-responsive';
import matchMedia from 'matchmediaquery';
// import Drawer from './drawer';
import Courses from './courses';
import Course from './course';
import Tests from './tests';
import Test from './test';
import Exam from './test/exam.container';
import Exams from './exams';
import BulletinBoard from './bulletin-board';
import CourseAll from './course-all';
import TestAll from './test-all';
import Results from './results';
import Search from './search';
import Impress from '../impress';
import Footer from '../footer';
import theme from '../app.theme';
import Divider from '@material-ui/core/Divider';
import Avatar from '@material-ui/core/Avatar';
import FaceIcon from '@material-ui/icons/Face';
import Notifications from './notification-center/notification-center-popover.container';
import Grid from '@material-ui/core/Grid';
import Badge from '@material-ui/core/Badge';
import Profile from './profile';
import NotificationCenter from './notification-center';
import Typography from '@material-ui/core/Typography';
import { CourseCompletedDialog, TestCompletedDialog } from './dialogs';

import { ThemeImages, ThemeColors } from '../theme';

import ENV from '../../run-config';
import meinCoach from '../../images/logo_rlb_header.png';
import logout from '../../images/logout.png';
import Theme from '../app.theme';
import SocialWall from './socialwall';
import SingleSocialWallPost from './socialwall/single-socialwall-post.container';

class Main extends Component {

  constructor(props) {
    super(props);

    this.state = {
      drawerOpen: false,
      profileTooltipOpen: false,
    };

    this.courseBaseUrl = `${this.props.match.url}courses`;
    this.testBaseUrl = `${this.props.match.url}tests`;
    this.resultBaseUrl = `${this.props.match.url}results`;
    this.searchBaseUrl = `${this.props.match.url}search`;
    this.profileBaseUrl = `${this.props.match.url}profile`;
    this.examsBaseUrl = `${this.props.match.url}exams`;
    this.bulletinBoardUrl = `${this.props.match.url}bulletinboard`;
    this.socialWallUrl = `${this.props.match.url}socialwall`;
    this.notificationCenterUrl = `${this.props.match.url}notificationCenter`;

    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.onTestsSelected = this.onTestsSelected.bind(this);
    this.onCoursesSelected = this.onCoursesSelected.bind(this);
    this.onResultsSelected = this.onResultsSelected.bind(this);
    this.onHomeSelected = this.onHomeSelected.bind(this);
    this.onNavigate = this.onNavigate.bind(this);
  }

  onCoursesSelected() {
    this.props.history.push(this.courseBaseUrl);
    this.props.onLoadCourses();
    this.props.onCloseCompletedDialog();
    this.closeDrawer();
  }

  onBulletinBoardSelected = () => {
    if (this.props.bulletinBoard) {
      this.props.getPinnedContentAction(this.props.bulletinBoard.id, {});
    }

    this.props.history.push(this.bulletinBoardUrl);
  }


  onSocialWallSelected = () => {
    // if (this.props.bulletinBoard) {
    //   console.log('load')
    //   this.props.getPinnedContentAction(this.props.bulletinBoard.id, {});
    // }

    this.props.history.push(this.socialWallUrl);
  }

  onExamsSelected = () => {
    this.props.history.push(this.examsBaseUrl);
    this.props.loadExams();
  }

  onTestsSelected = () => {
    this.props.history.push(this.testBaseUrl);
    this.props.onLoadTests();
    this.props.onLoadResults();
    this.props.onCloseCompletedDialog();
    this.closeDrawer();
  }

  onResultsSelected = () => {
    this.props.history.push(this.resultBaseUrl);
    this.props.onLoadResults();
    this.props.onCloseCompletedDialog();
    this.closeDrawer();
  }

  onHomeSelected() {
    this.onNavigate('/courses');
  }

  componentWillMount() {
    this.props.onLoadResults();
    this.updateDimensions();
    this.props.onLoadCourses();
    this.props.onLoadTests();
    this.props.loadUserInfo();
    this.props.loadConfig();
    this.props.loadBulletinBoard();
    this.props.loadUserRoles();
    this.props.loadUserGroups();
    this.props.loadNotifications();
  }

  onProfileSelected = () => {

  }

  handleOnProfileClick = () => {
    this.props.history.push(this.profileBaseUrl);
    this.setState({ profilTooltipOpen: false });
  }


  handleTooltipVisibility = (open) => {
    this.setState({
      profilTooltipOpen: open,
    });
  }

  handleOnLogoutClick = () => {
    this.setState({ profilTooltipOpen: false });
    this.props.onLogout();
  }

  onNavigate(path) {
    this.props.history.push(path);
    this.closeDrawer();
  }

  toggleDrawer() {
    this.setState({
      drawerOpen: !this.state.drawerOpen,
    });
  }

  closeDrawer() {
    this.setState({
      drawerOpen: false,
    });
  }

  contentStyle() {
    return {
      marginLeft: this.state.drawerOpen
                ? 256
                : 0,
      transition: '450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
    };
  }

  onInfoSelected() {

  }

  updateDimensions() {
    this.setState({ mobileViewPort: matchMedia('(max-width: 1060px)').matches });
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions.bind(this));
  }

  toggleProfileTooltip = () => {
    this.setState({ profileTooltipOpen: !this.state.profileTooltipOpen });
  }

  renderLogo() {
    return (<img onClick={ENV.unlinkedHeaderLogo ? undefined : this.onHomeSelected.bind(this)} style={{ height: '60px', marginRight: 30, marginTop: 20 }} src={ThemeImages.iconPath} />);
  }

  renderLogoRlb() {
    return (<img onClick={ENV.unlinkedHeaderLogo ? undefined : this.onHomeSelected.bind(this)} style={{ height: '50px', marginRight: 30 }} src={meinCoach} />);
  }

  isActiveRoute(name) {
    return this.props.location.pathname.indexOf(`/${name}`) === 0;
  }

  renderAppbarRLB() {
    const activeStyles = { color: '#444', paddingLeft: 0, paddingRight: 0, marginRight: 26, marginLeft: 26, borderBottomColor: ThemeColors.primary1Color, borderBottomWidth: 3, borderBottomStyle: 'solid' };
    const buttonLabelStyles = { color: '#444', paddingLeft: 0, paddingRight: 0, marginRight: 26, marginLeft: 26 };

    return (<AppBar
      iconStyleLeft={{ marginTop: '20px', color: 'black', fill: 'black' }}
      style={{ height: '80px', backgroundColor: 'transparent', color: '#333333', boxShadow: '', height: 100 }}
      showMenuIconButton={this.state.mobileViewPort}
      titleStyle={{ display: 'none' }}
      onLeftIconButtonClick={this.toggleDrawer}
    >
      <MediaQuery query="(min-width: 992px)">
        <div className="col-lg-offset-1 col-md-12 col-lg-10" style={{ marginTop: '15px', alignItems: 'center' }}>
          <div className="col-lg-2 col-md-2">
            {this.renderLogoRlb()}
          </div>

          <div className="col-lg-8 col-md-8 centered-text" style={{ display: 'flex', justifyContent: 'center' }}>
            <div style={{ textAlign: 'center', marginTop: 50 }}>
              <Button labelStyle={this.isActiveRoute('courses') ? activeStyles : buttonLabelStyles} onClick={this.onCoursesSelected} label="Inhalte" color="primary" />
              <Button labelStyle={this.isActiveRoute('tests') ? activeStyles : buttonLabelStyles} onClick={this.onTestsSelected} label="Quiz" color="primary" />
              {/* <Button labelStyle={this.isActiveRoute('exams') ? activeStyles : buttonLabelStyles} onClick={this.onExamsSelected} label="Prüfungen" color="primary" /> */}
              <Button labelStyle={this.isActiveRoute('results') ? activeStyles : buttonLabelStyles} onClick={this.onResultsSelected} label="Ergebnisse" color="primary" />

            </div>
          </div>
          <div className="pull-right" style={{ marginTop: '10px' }}>
            <Button style={{ height: 40 }}labelStyle={{ color: '#444' }} onClick={this.props.onLogout} label="Logout" color="primary" icon={<img src={logout} style={{ width: 30, height: 30, margin: 5 }} />} />
          </div>
        </div>
      </MediaQuery>
      <MediaQuery query="(max-width: 991px)">
        <div
          style={{
          // marginTop: '15px',
            width: '100%',
            textAlign: 'center' }}
        >
          <img onClick={this.onHomeSelected.bind(this)} style={{ height: '60px', marginLeft: '-40px', display: this.state.drawerOpen ? 'none' : null }} src={ThemeImages.iconPath} />
        </div>
      </MediaQuery>
    </AppBar>
    );
  }

  renderUserAvatar() {
    const avatarStyle = {
      marginRight: 10,
    };

    if (!this.props.user) return null;

    return this.props.user.avatarUrl
      ? (<Avatar style={avatarStyle} src={this.props.user.avatarUrl} size={40} />)
      : (<Avatar style={avatarStyle}><FaceIcon /></Avatar>);
  }

  renderProfileTooltip() {
    if (!this.props.user) return null;
    return (
      <ProfileTooltip
        title={this.renderTooltipContent()}
    // open
        open={this.state.profilTooltipOpen}
        onClose={() => this.setState({ profilTooltipOpen: false })}
      >
        <Grid container style={{ margin: '20px 0 10px 10px' }}>
          <Grid
            item
            style={{ cursor: 'pointer' }}
            onClick={() => this.handleTooltipVisibility(true)}
          >
            {this.renderUserAvatar()}

          </Grid>

          <Grid
            item
        // alignItems="center"
            style={{ marginLeft: 10, cursor: 'pointer', display: 'flex', alignItems: 'center' }}
            onClick={() => this.handleTooltipVisibility(true)}
          >
            <Grid container direction="column">
              <Typography color="primary" style={{ fontSize: 12, fontWeight: 'bold' }}>
                {this.props.user.firstName} {this.props.user.lastName}
              </Typography>
            </Grid>
          </Grid>
        </Grid>

      </ProfileTooltip>
    );
  }

  renderTooltipContent() {
    return (
      <Grid container direction="column">
        <Grid container alignItems="center" spacing={8}>
          <Grid item xs={3}>{this.renderUserAvatar(this.props.user)}</Grid>
          <Grid item xs={9} alignItems="center" style={{ marginTop: 4 }}>
            <Grid container direction="column">
              <Typography
                style={{ fontSize: 10, maxWidth: '100%', overflow: 'hidden' }}
              >
                {this.props.user.firstName} {this.props.user.lastName}
              </Typography>
              <Typography
                style={{ fontSize: 10, maxWidth: '100%', overflow: 'hidden' }}
              >
                {this.props.user.email}
              </Typography>
              <Typography
                color="primary"
                onClick={this.handleOnProfileClick}
                style={{ fontSize: 12, fontWeight: 'bold', cursor: 'pointer' }}
              >
                {'Profil & Einstellungen'}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item style={{ borderTop: `1px solid ${Theme.palette.divider}`, paddingTop: 5, marginTop: 5 }}>
          <Grid container>
            <Typography
              color="primary"
              onClick={this.handleOnLogoutClick}
              style={{ fontSize: 12, fontWeight: 'bold', cursor: 'pointer' }}
            >
              {'Abmelden'}
            </Typography>
            {/* <Button color="primary" label="Abmelden" onClick={this.handleOnLogoutClick} /> */}
          </Grid>
        </Grid>
      </Grid>
    );
  }

  renderAppbar() {
    if (ENV.brand == 'rlb') {
      return this.renderAppbarRLB();
    }
    const activeStyles = {
      color: ThemeColors.accent1Color,
      // color: '#444',
      paddingLeft: 0,
      paddingRight: 0,
      // paddingTop: 10,
      padding: '25px 0',
      // paddingTop: 19,
      // paddingBottom: 19,
      height: 64,
      borderTopWidth: 3,
      minWidth: 60,
      marginLeft: 10,
      marginRight: 10,
      textTransform: 'none',
      borderTopStyle: 'solid',
      borderTopColor: ThemeColors.accent1Color,
      // borderBottomColor: ThemeColors.primary1Color,
      // borderBottomWidth: 3,
      // borderBottomStyle: 'solid',
    };
    const buttonLabelStyles = {
      color: '#444',
      paddingLeft: 0,
      paddingRight: 0,
      height: 64,
      textTransform: 'none',
      padding: '28px 0',
      marginLeft: 10,
      marginRight: 10,
      minWidth: 60,
    };

    const examItem = this.props.config.examsEnabled && this.props.config.examsEnabled === 'false'
    ? null
    : (
      <Badge badgeContent={0} variant="dot" color="primary"><Button labelStyle={this.isActiveRoute('exams') ? activeStyles : buttonLabelStyles} onClick={this.onExamsSelected} label="Prüfungen" color="primary" /></Badge>
    );

    const bulletinBoardItem = this.props.config.bulletinBoardActive && this.props.config.bulletinBoardActive === 'true'
    ? <Button labelStyle={this.isActiveRoute('bulletinboard') ? activeStyles : buttonLabelStyles} onClick={this.onBulletinBoardSelected} label="Meine Inhalte" color="primary" />
    : null;

    const socialWallItem = this.props.config.socialWallActive && this.props.config.socialWallActive === 'true'
    ? <Button labelStyle={this.isActiveRoute('socialwall') ? activeStyles : buttonLabelStyles} onClick={this.onSocialWallSelected} label="Social Wall" color="primary" />
    : null;

    return (<AppBar
      className="doNotPrint"
      elevation={0}
      iconStyleLeft={{ marginTop: '20px', color: 'black', fill: 'black' }}
      style={{ height: '60px', backgroundColor: 'transparent', color: '#333333' }}
      showMenuIconButton={this.state.mobileViewPort}
      titleStyle={{ display: 'none' }}
      onLeftIconButtonClick={this.toggleDrawer}
    >
      <MediaQuery query="(min-width: 1060px)">
        <div className="col-md-12 col-lg-12" style={{ alignItems: 'center', display: 'flex', justifyContent: 'space-between', maxWidth: 1200, float: 'none', marginLeft: 'auto', marginRight: 'auto' }}>
          {this.renderLogo()}
          <div style={{}}>
            <Button labelStyle={this.isActiveRoute('courses') ? activeStyles : buttonLabelStyles} onClick={this.onCoursesSelected} label="Inhalte" color="primary" />
            <Button labelStyle={this.isActiveRoute('tests') ? activeStyles : buttonLabelStyles} onClick={this.onTestsSelected} label="Test" color="primary" />
            {examItem}
            <Button labelStyle={this.isActiveRoute('results') ? activeStyles : buttonLabelStyles} onClick={this.onResultsSelected} label="Ergebnisse" color="primary" />
            {bulletinBoardItem}
            {socialWallItem}
          </div>

          <div className="pull-right">
            {this.renderUserAvatarAndProfile()}
          </div>
        </div>
      </MediaQuery>
      <MediaQuery query="(max-width: 1060px)">
        <div
          style={{
          // marginTop: '15px',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            // textAlign: 'center'
          }}
        >
          <div />
          {/* <img onClick={this.onHomeSelected.bind(this)} style={{ height: '60px', marginLeft: '-40px', display: this.state.drawerOpen ? 'none' : null }} src={ThemeImages.iconPath} /> */}
          {this.renderUserAvatarAndProfile()}
        </div>
      </MediaQuery>
    </AppBar>);
  }

  renderUserAvatarAndProfile() {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Notifications history={this.props.history} />
        {this.renderProfileTooltip()}
      </div>
    );
  }

  render() {
    return (
      <div>
        <Drawer
          open={this.state.drawerOpen}
          closeDrawer={() => this.setState({ drawerOpen: false })}
          basePath={this.props.match.url}
          onCoursesSelected={this.onCoursesSelected}
          onTestsSelected={this.onTestsSelected}
          onHomeSelected={this.onHomeSelected}
          onResultsSelected={this.onResultsSelected}
          onExamsSelected={this.onExamsSelected}
          onSocialWallSelected={this.onSocialWallSelected}
          onBulletinBoardSelected={this.onBulletinBoardSelected}
          onInfoSelected={this.onInfoSelected}
          onNavigate={this.onNavigate}
        />
        <div style={this.contentStyle()}>
          {this.renderAppbar()}
          <div
            style={{
              marginTop: 10,
              padding: 10,
              maxWidth: 1200,
              marginLeft: 'auto',
              marginRight: 'auto',
              float: 'none',
            }}
          >
            <Route path={`${this.courseBaseUrl}`} component={Courses} exact />
            <Route path={`${this.courseBaseUrl}/:courseId`} component={Course} exact />
            <Route path={`${this.courseBaseUrl}/:courseId/all`} component={CourseAll} exact />
            <Route path={`${this.testBaseUrl}`} component={Tests} exact />
            <Route path={`${this.testBaseUrl}/:testId`} component={Test} exact />
            <Route path={`${this.testBaseUrl}/:testId/all`} component={TestAll} exact />
            <Route path={`${this.socialWallUrl}`} component={SocialWall} exact />
            <Route path={`${this.socialWallUrl}/:socialWallPostId`} component={SingleSocialWallPost} exact />
            <Route path={`${this.examsBaseUrl}`} component={Exams} exact />
            <Route path={`${this.examsBaseUrl}/:testId`} component={Exam} exact />
            <Route path={`${this.resultBaseUrl}`} component={Results} exact />
            <Route path={`${this.resultBaseUrl}/:resultId`} component={Test} exact />
            <Route path={`${this.resultBaseUrl}/:resultId/all`} component={TestAll} exact />
            <Route path={`${this.bulletinBoardUrl}`} component={BulletinBoard} exact />
            <Route path={this.notificationCenterUrl} component={NotificationCenter} exact />
            <Route path={this.searchBaseUrl} component={Search} exact />
            <Route path="/profile" component={Profile} exact />
            <CourseCompletedDialog history={this.props.history} onCoursesSelected={this.onCoursesSelected} />
            <TestCompletedDialog
              onTestsSelected={this.onTestsSelected}
              onResultsSelected={this.onResultsSelected}
            />

          </div>
        </div>
      </div>
    );
  }
}

Main.propTypes = {
  match: PropTypes.any.isRequired,
  title: PropTypes.string.isRequired,
  history: PropTypes.any.isRequired,
  config: PropTypes.object,
};

Main.defaultProps = {
  config: {},
};

export default Main;



// WEBPACK FOOTER //
// ./src/app/main/main.js